export const consumerFundingSource = [
  {
    label: "Retail load networks in cash",
    value: "retail-load-networks-in-cash",
  },
  {
    label: "Load from payment card (credit or debit)",
    value: "credit-or-debit",
  },
  {
    label: "Load from bank account (B2C ACH)",
    value: "from-bank-account",
  },
  { label: "Direct deposit", value: "direct-deposit" },
];
export const corporateFundingSource = [
  { label: "ACH/Electronic transfer", value: "electronic-transfer" },
  { label: "Others", value: "other" },
  {
    label: "N/A",
    value: "n/a",
  },
];
export const cardPlacement = [
  {
    label: "Cardholders will place an order for individual cards",
    value: "individual-cards",
    supportText:
      "Card holders can use C-Cart or WebPOS to place orders for a single card",
  },
  {
    label: "Program Managers/Partners will bulk order cards",
    value: "bulk-order-cards",
    supportText:
      "Bulk card order requests can be sent in through the Partner Portal (C-Partner), Batch File (CH-Auth Batch) or API.",
  }
];
export const cardChannelIndividual = [
  { label: "Bulk Uploads", value: "bulk-uploads" },
  { label: "C-Partner", value: "c-partner" },
  { label: "Order from retail WebPOS", value: "web-pos" },
  { label: "APIs", value: "apis" },
];
export const cardChannelBulk = [
  {
    label: "Bulk uploads through a batch file (CH-Auth File)",
    value: "bulk-uploads",
  },
  { label: "C-Partner", value: "c-partner" },
  { label: "APIs", value: "apis" },
];
export const cardChannelAll = [
  { label: "Card enrollment (C-Cart) web app", value: "c-cart-web" },
  { label: "Card enrollment (C-Cart) mobile app", value: "c-cart-mobile" },
  { label: "Bulk uploads through a batch file (CH-Auth File)", value: "bulk-uploads" },
  { label: "Partner portal (C-Partner)", value: "c-partner" },
  { label: "WebPOS", value: "web-pos" },
  { label: "API", value: "api" },
  { label: "Other", value: "other" },
];
export const cardsActivationChannel = [
  { label: "IVR", value: "ivr" },
  { label: "Live operator", value: "live-operator" },
  { label: "Cardholder website", value: "cardholder-website" },
  { label: "Mobile app", value: "mobile-app" },
  {label: "i2c Mobile app SDK (required for Non-PCI compliant Issuers)", value: "mobile-app-sdk"},
  { label: "WebPOS", value: "web-pos" },
  { label: "API", value: "api" },
  { label: "Others", value: "other" },
];
export const customerSupportChannel = [
  { label: "IVR", value: "ivr" },
  { label: "Live Agent Support (Call Agent)", value: "live-agent" },
];
export const cardholderNotify = [
  { label: "Send alerts to Cardholders", value: "send-to-holders" },
  {
    label: "Send alerts data to Program Managers",
    value: "send-to-managers",
  },
  { label: "N/A", value: "n/a" },
];
export const customerSupportProviders = [
  { label: "i2c Inc", value: "i2c" },
  {
    label: "Client/Third Party",
    value: "client-third-party",
  },
  {
    label: "N/A",
    value: "n/a",
  },
];
export const notificationChannels = [
  { label: "Email Alerts", value: "email-alerts" },
  { label: "Text Alerts", value: "text-alerts" },
  { label: "Push Notifications", value: "push-notification" },
  {
    label: "N/A",
    value: "n/a",
  },
];
export const kycResponsibility = [
  {
    label: "Managed by the i2c platform, based upon program settings",
    value: "managed-by-the-i2c-platform-based-upon-program-settings",
  },
  {
    label: "Managed-by-Issuer/ISO/Sponsor-Bank",
    value: "managed-by-issuer-iso-sponsor-bank",
  },
  {
    label: "Other",
    value: "other",
  },
  {
    label: "N/A",
    value: "n/a",
  },
];
export const cardActivationMethod = [
  { label: "Activation on first load", value: "on-first-load" },
  { label: "Generate Activated Cards", value: "generate-activated" },
];


export const keyProcess = ["Yes", "No", "N/A"];

export const fundingSource = [
  {
    label: "Loaded by the consumer through",
    value: "loaded-by-the-consumer-through",
  },
  {
    label: "Loaded by a corporate entity through",
    value: "loaded-by-a-corporate-entity-through",
  },
  {
    label: "N/A",
    value: "n/a",
  },
];

export const secondaryCardOption = ["Yes", "No", "N/A"];
export const shareBalance = ["Yes", "No", "N/A"];
export const ownProfile = ["Yes", "No", "N/A"];
export const offlinePin = ["Yes", "No", "N/A"];

export const cardActivationParameter = [
  {
    label: "Last four digits of SSN",
    value: "last-four-digits-of-ssn",
  },
  {
    label: "ZIP Code",
    value: "zip-code",
  },
  {
    label: "Last four digits of mobile phone number",
    value: "last-four-digits-of-mobile-phone-number",
  },
  {
    label: "Last four digits of home phone number",
    value: "last-four-digits-of-home-phone-number",
  },
  {
    label: "Tax ID (for corporate account activation only)",
    value: "tax-id-for-corporate-account-activation-only",
  },
  {
    label: "CVV of the issued card",
    value: "cvv-of-the-issued-card",
  },
  {
    label: "Expiration date of the issued card",
    value: "expiration-date-of-the-issued-card",
  },
];
export const cardReloadingOptions = [
  {
    label: "Greendot (US Only)",
    value: "greendot-us-only",
  },
  {
    label: "Western Union (US Only)",
    value: "western-union-us-only",
  },
  {
    label: "Moneygram (US Only)",
    value: "moneygram-us-only",
  },
  {
    label: "Visa ReadyLink (US Only)",
    value: "visa-readylink-us-only",
  },
  {
    label: "Debit/Credit cards",
    value: "debit-credit-cards",
  },
  {
    label: "ACH",
    value: "ach",
  },
  {
    label: "Other",
    value: "other",
  },
];
export const fields = [
  "pf_enable_kyc_conduct",
  "pf_enable_kyc_conduct_no_reason",
  "pf_kyc_conduct",
  "pf_kyc_conduct_other",
  "pf_funding_source_consumer_option",
  "pf_funding_source_corporate_option",
  "pf_funding_source_corporate_other_company",
  "pf_funding_source_corporate_other_contact_name",
  "pf_funding_source_corporate_other_title",
  "pf_funding_source_corporate_other_phone",
  "pf_funding_source_corporate_other_phone_country",
  "pf_funding_source_corporate_other_email",
  "pf_funding_source_corporate_other_address",
  "pf_card_placement",
  "pf_card_placement_channel",
  "pf_card_placement_channel_other",
  "pf_supplimentary_cards_permitted",
  "pf_supplimentary_cards_age_limit",
  "supplimentary_cards_own_profile",
  "supplimentary_cards_share_primary_balance",
  "pf_card_activation_required",
  "pf_card_activation_method",
  "pf_card_activation_channels",
  "pf_card_activation_channels_other",
  "pf_card_offline_pin_required",
  "pf_cardholder_notifications",
  "pf_cardholder_notifications_channels",
  "pf_customer_support_channels",
  "pf_customer_support_provider",
  "pf_customer_support_provider_other_company",
  "pf_customer_support_provider_other_contact_name",
  "pf_customer_support_provider_other_title",
  "pf_customer_support_provider_other_phone",
  "pf_customer_support_provider_other_phone_country",
  "pf_customer_support_provider_other_email",
  "pf_card_activation_parameters",
  "pf_card_reloading_options",
  "pf_card_reloading_options_other",
  "pf_card_closure_how_will_card_be_closed",
  "pf_card_closure_how_will_card_account_balance_be_treated_at_card_closure",
];